import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HFTextInput from 'components/HFInputs/HFTextInput'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from './TaskPaymentsController.module.sass'

const TaskPaymentsController = () => {
	const { i18n } = useGlobal()

	return (
		<fieldset>
			<VStack className={styles['payments-root-container']}>
				<h4>{i18n`Payments`}</h4>
				<HStack className={styles['payments-container']}>
					<VStack className={styles['payments-row']}>
						<h5>{i18n`Amount to be Charged to the Athlete`}</h5>
						<HFTextInput
							type='number'
							name='injuredChargeAmount'
							multiline={false}
							inputMode={'numeric'}
							noResize
						/>
					</VStack>
					<VStack className={styles['payments-row']}>
						<h5>{i18n`Amount to be Charged to the Trust`}</h5>
						<HFTextInput
							type='number'
							name='chargeAmount'
							multiline={false}
							inputMode={'numeric'}
							noResize
						/>
					</VStack>
				</HStack>
			</VStack>
		</fieldset>
	)
}

export default TaskPaymentsController
